export default {
  default: ['value', 'label', 'name', 'options', 'info', 'disabled', 'required', 'hidden'],
}
